import { CheckBoxLabel } from '@UI/CheckBox'
import { Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons';
import s from './index.module.css'

export const IgnoreSpacesAndCase = ({ data, edit }) => {
    return <div className={s.checkboxContainer}>
        <CheckBoxLabel
            value={data.ignore_spaces_and_case}
            onClick={() =>
                edit((prev) => ({
                    ...prev,
                    ignore_spaces_and_case: !data.ignore_spaces_and_case,
                }))
            }
            label='Игнорировать пробелы и заглавные буквы'
        />
        <Tooltip title="При включении этого чекбокса пробелы и регистр не учитываются в ответах, включая те, что указаны в правильном ответе.">
            <InfoCircleOutlined className={s.infoTooltip} />
        </Tooltip>
    </div>
}
 